import { Component, ElementRef, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import PerfectScrollbar from 'perfect-scrollbar';
import { Subscription } from 'rxjs';
import { OAuthServiceService } from 'shared';
import { TenantService } from 'shared';

@Component({
    selector: 'squirrel-layout',
    templateUrl: './squirrel-layout.component.html',
    styleUrls: ['./squirrel-layout.component.scss'],
    standalone: false
})
export class SquirrelLayoutComponent implements OnInit {

  isAuthenticated: boolean = false;
 
  private _router!: Subscription;
  private lastPoppedUrl: any;
  private yScrollStack: number[] = [];

  constructor(public location: Location,
    private router: Router,
    private oauthService: OAuthServiceService,
    private tenantService: TenantService,
    private elementRef: ElementRef,
  ) { }
 
  ngOnInit() {

      // const isWindows = navigator.platform.indexOf('Win') > -1 ? true : false;

      // if (isWindows && !document.getElementsByTagName('body')[0].classList.contains('sidebar-mini')) {
      //   // if we are on windows OS we activate the perfectScrollbar function

      //   document.getElementsByTagName('body')[0].classList.add('perfect-scrollbar-on');
      // } else {
      //   document.getElementsByTagName('body')[0].classList.remove('perfect-scrollbar-off');
      // }
      // const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
      // const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');

      // this.location.subscribe((ev: PopStateEvent) => {
      //   this.lastPoppedUrl = ev.url as string;
      // });
      // this.router.events.subscribe((event: any) => {
      //   if (event instanceof NavigationStart) {
      //     if (event.url != this.lastPoppedUrl)
      //       this.yScrollStack.push(window.scrollY);
      //   } else if (event instanceof NavigationEnd) {
      //     if (event.url == this.lastPoppedUrl) {
      //       this.lastPoppedUrl = undefined;           
      //       //window.scrollTo(0, this.yScrollStack.pop());
      //       window.scrollTo(0, this.yScrollStack.pop()!); // NB:: the exclamation mark here, tells Typescript to trust me that it's not null
      //     } else
      //       window.scrollTo(0, 0);
      //   }
      // });

      // this._router = this.router.events.pipe(filter(event => event instanceof NavigationEnd))
      // .subscribe((event: any) => {
      //   elemMainPanel.scrollTop = 0;
      //   elemSidebar.scrollTop = 0;
      // });       

      // if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      //   let ps = new PerfectScrollbar(elemMainPanel);
      //   ps = new PerfectScrollbar(elemSidebar);
      // }
  }

  // @HostListener('document:mouseover', ['$event']) mouseover(event:any) {

  //      if(event.target.matches('.ag-theme-balham')) {
  //     const agBodyViewport: HTMLElement = this.elementRef.nativeElement.querySelector('#secondGrid .ag-body-viewport');
  //     const agBodyHorizontalViewport: HTMLElement = this.elementRef.nativeElement.querySelector('#secondGrid .ag-body-horizontal-scroll-viewport');
  //     if (agBodyViewport) {
  //       const ps = new PerfectScrollbar(agBodyViewport);
  //       ps.update();
  //     }
  //     if (agBodyHorizontalViewport) {
  //       const ps = new PerfectScrollbar(agBodyHorizontalViewport);
  //       ps.update();
  //     }
  // }
  //   //this.runOnRouteChange();
  // }

  isMaps(path: any) {
    let titlee = this.location.prepareExternalUrl(this.location.path());
    titlee = titlee.slice(1);
    if (path == titlee) {
      return false;
    }
    else {
      return true;
    }
  }

  runOnRouteChange(): void {
    if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
      const elemMainPanel = <HTMLElement>document.querySelector('.main-panel');
      const ps = new PerfectScrollbar(elemMainPanel);
      ps.update();
    }
  }

  isMac(): boolean {
    let bool = false;
    if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
      bool = true;
    }
    return bool;
  }

  login() {
    this.oauthService.doLogin();
  }
}
